import { render, staticRenderFns } from "./FacebookNewsFeedCreative.vue?vue&type=template&id=43626384&scoped=true&"
import script from "./FacebookNewsFeedCreative.vue?vue&type=script&lang=ts&"
export * from "./FacebookNewsFeedCreative.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookNewsFeedCreative.vue?vue&type=style&index=0&id=43626384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43626384",
  null
  
)

export default component.exports